import { Box, Button, Tooltip } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { quoteModern } from "../style/style";

export const QuotePdfButtons = ({ quoteUri }) => {
  const handleDownload = () => {
    if (quoteUri) {
      window.open(quoteUri, "_blank");
    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <Tooltip title={quoteUri ? "Download estimate PDF" : "PDF not available"}>
        <span>
          <Button
            onClick={handleDownload}
            disabled={!quoteUri}
            variant="outlined"
            size="small"
            sx={{
              minWidth: 40,
              width: 40,
              height: 40,
              p: 0,
              borderRadius: 2,
              border: `1px solid ${quoteModern.colors.orange}`,
              color: quoteModern.colors.orange,
              bgcolor: "var(--fx-surface-base, #FFFFFF)",
              boxShadow: quoteModern.colors.shadow,
              transition: "all 0.2s ease",
              "&:hover": {
                bgcolor: quoteModern.colors.orange,
                color: "#FFFFFF",
                borderColor: quoteModern.colors.orange,
                transform: "translateY(-1px)",
              },
              "&:disabled": {
                borderColor: quoteModern.colors.line,
                color: quoteModern.colors.textSoft,
                bgcolor: "var(--fx-surface-base, #FFFFFF)",
              },
            }}
          >
            <FileDownloadIcon sx={{ fontSize: 18 }} />
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};
